import React from "react";
import Helmet from "react-helmet";
import { Container } from "react-bootstrap";

import { PageHeader } from "../component/pure/home/pageHeader";

export function Privacidad() {
  return (
    <>
      <Helmet>
        <title>EyC - Política de Privacidad</title>
      </Helmet>

      <PageHeader section='Política de Privacidad' />

      <Container className="py-5">
        <h2 className="mb-4">Política de Privacidad – Corralón EYC</h2>

        <p>
          En Corralón EYC nos comprometemos a proteger la privacidad de los usuarios que visitan
          nuestro sitio web. Esta Política de Privacidad describe cómo recopilamos, utilizamos
          y protegemos la información personal que los usuarios proporcionan al interactuar con nuestro sitio.
        </p>

        <h4 className="mt-4">1. Información que recopilamos</h4>

        <p>Podemos recopilar información personal que los usuarios proporcionan voluntariamente al utilizar nuestro sitio web, como por ejemplo:</p>

        <ul>
          <li>Nombre y apellido</li>
          <li>Número de teléfono</li>
          <li>Dirección de correo electrónico</li>
          <li>Dirección de entrega o ubicación</li>
          <li>Información relacionada con consultas o pedidos</li>
        </ul>

        <p>También podemos recopilar información no personal de forma automática, como:</p>

        <ul>
          <li>Dirección IP</li>
          <li>Tipo de navegador</li>
          <li>Dispositivo utilizado</li>
          <li>Páginas visitadas dentro del sitio</li>
          <li>Fecha y hora de acceso</li>
        </ul>

        <p>
          Esta información se utiliza únicamente con fines estadísticos y para mejorar la experiencia de navegación.
        </p>

        <h4 className="mt-4">2. Uso de la información</h4>

        <p>La información recopilada puede ser utilizada para:</p>

        <ul>
          <li>Responder consultas o solicitudes realizadas por los usuarios</li>
          <li>Brindar información sobre productos o servicios</li>
          <li>Gestionar pedidos o presupuestos</li>
          <li>Mejorar la calidad del servicio y del sitio web</li>
          <li>Enviar comunicaciones relacionadas con la actividad comercial del Corralón EYC</li>
        </ul>

        <p>
          En ningún caso utilizaremos la información para fines distintos a los mencionados
          sin el consentimiento del usuario.
        </p>

        <h4 className="mt-4">3. Protección de la información</h4>

        <p>
          Corralón EYC adopta medidas de seguridad técnicas y organizativas adecuadas para proteger
          la información personal contra accesos no autorizados, pérdida, alteración o divulgación.
        </p>

        <p>
          No obstante, ningún sistema de transmisión o almacenamiento de datos en internet es
          completamente seguro, por lo que no podemos garantizar una seguridad absoluta.
        </p>

        <h4 className="mt-4">4. Compartición de información</h4>

        <p>
          Corralón EYC no vende, alquila ni comparte información personal de los usuarios con terceros,
          excepto en los siguientes casos:
        </p>

        <ul>
          <li>Cuando sea necesario para prestar un servicio solicitado por el usuario</li>
          <li>Cuando sea requerido por autoridades legales o judiciales</li>
          <li>Cuando sea necesario para proteger derechos legales del negocio</li>
        </ul>

        <h4 className="mt-4">5. Uso de cookies</h4>

        <p>
          Este sitio puede utilizar cookies para mejorar la experiencia de navegación. Las cookies
          permiten reconocer el navegador del usuario y recordar ciertas preferencias.
        </p>

        <p>
          El usuario puede configurar su navegador para rechazar cookies si lo desea, aunque esto
          podría afectar el funcionamiento de algunas secciones del sitio.
        </p>

        <h4 className="mt-4">6. Enlaces a sitios externos</h4>

        <p>
          Nuestro sitio web puede contener enlaces a sitios web de terceros. Corralón EYC no se
          responsabiliza por las políticas de privacidad o el contenido de dichos sitios externos.
        </p>

        <h4 className="mt-4">7. Derechos de los usuarios</h4>

        <p>Los usuarios pueden solicitar en cualquier momento:</p>

        <ul>
          <li>Acceder a los datos personales que se hayan recopilado</li>
          <li>Corregir información incorrecta</li>
          <li>Solicitar la eliminación de sus datos</li>
        </ul>

        <p>
          Para realizar estas solicitudes, pueden comunicarse a través de los canales de contacto
          publicados en el sitio.
        </p>

        <h4 className="mt-4">8. Cambios en la política de privacidad</h4>

        <p>
          Corralón EYC se reserva el derecho de modificar esta Política de Privacidad en cualquier momento.
          Las modificaciones serán publicadas en esta misma sección del sitio web.
        </p>

        <h4 className="mt-4">9. Contacto</h4>

        <p>
          Si tiene preguntas sobre esta Política de Privacidad o sobre el tratamiento de sus datos personales,
          puede comunicarse con nosotros a través de los medios de contacto disponibles en el sitio web
          oficial de Corralón EYC.
        </p>

      </Container>

    </>
  )
}